import { ICommentResource } from "../../comments";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";

export type ICommentDeleteMutationParameters = {
    comment: RelationalValue<ICommentResource>;
};

export type ICommentDeleteMutationResult = void;

export const commentDeleteMutation: IApiMutationFunction<ICommentDeleteMutationParameters> = ({ comment }) => {
    return {
        method: "DELETE",
        url: `/comments/${mapRelationalValue(comment)}`,
    };
};

export const useCommentDeleteMutation = createApiMutationHook<
    ICommentDeleteMutationParameters,
    ICommentDeleteMutationResult
>(commentDeleteMutation);
